
class Node {
    constructor(nodeData) {
        this.id = nodeData.id;
        this.edges = [];
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.temporary = !!nodeData.temporary;
        this.isRoot = !!nodeData.isRoot;
        this.level = this.isRoot ? 0 : -1;
        this.data = nodeData;
        this.isFree = false;
    }
}

export default Node;


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/structures/Node.js